import { put, take, takeLatest, call, select } from 'redux-saga/effects';

import { Text } from '@frontend/legacy-components';
import { createStandaloneToast, theme } from '@frontend/legacy-components';

import { getDefaultFacility } from 'modules/settings/company/supplierFacilities/data/reducer';

import supplierSettingsService from 'services/supplierSettingsService';

import { supplierFacilityDrawer, open, save, types } from './actions';
import { MODES } from './constants';
import { getLogoId, getMode, getSupplierFacilityId } from './reducer';

const { toast } = createStandaloneToast({ theme });

export default function* root() {
  yield takeLatest(types.OPEN_REQUEST, watchInitiateDrawer);
  yield takeLatest(types.SAVE_REQUEST, watchSaveSupplierFacility);
}

function* watchInitiateDrawer(action) {
  try {
    const { callBack } = action.payload;
    const mode = yield select(getMode);
    if (mode === MODES.EDIT) {
      // fetch current supplier facility
      const supplierFacilityId = yield select(getSupplierFacilityId);
      const supplierFacility = yield call(
        supplierSettingsService.supplierFacilities.get,
        supplierFacilityId,
      );

      yield put(
        supplierFacilityDrawer.setSupplierFacility({ supplierFacility }),
      );
    }

    yield put(open.success());

    if (callBack) {
      const action = yield take(types.SAVE_SUCCESS);
      yield call(callBack, {
        supplierFacilityId: action.payload.supplierFacilityId,
      });
    }
  } catch (error) {
    yield put(open.error(error));
  }
}

function* watchSaveSupplierFacility(action) {
  try {
    const supplierFacilityId = yield select(getSupplierFacilityId);
    const oldDefaultFacility = yield select(getDefaultFacility);

    const {
      address1,
      address2,
      city,
      country,
      isDefault,
      deleteLogo,
      logoFile,
      name,
      phone,
      phoneExt,
      postalCode,
      state,
      url,
    } = action.payload;

    const address = {
      address1,
      address2,
      city,
      country,
      postalCode,
      state,
    };

    const requestData = {
      address,
      isDefault,
      name,
      phone,
      phoneExt,
      url,
    };

    const mode = yield select(getMode);
    let supplierFacilityResponse;
    if (mode == MODES.CREATE) {
      supplierFacilityResponse = yield call(
        supplierSettingsService.supplierFacilities.create,
        requestData,
      );
    } else {
      supplierFacilityResponse = yield call(
        supplierSettingsService.supplierFacilities.update,
        supplierFacilityId,
        requestData,
      );
    }
    // if the logo is null, delete it
    if (deleteLogo) {
      const logoId = yield select(getLogoId);
      if (logoId) {
        yield call(
          supplierSettingsService.supplierFacilities.logo.delete,
          logoId,
        );
      }
    } else if (logoFile) {
      const formData = new FormData();
      formData.append('file', logoFile);
      yield call(
        supplierSettingsService.supplierFacilities.logo.update,
        supplierFacilityResponse.id,
        formData,
      );
    }

    yield put(
      save.success({ supplierFacilityId: supplierFacilityResponse.id }),
    );
    if (
      isDefault &&
      oldDefaultFacility &&
      supplierFacilityId !== oldDefaultFacility?.id
    ) {
      yield call(toast, {
        status: 'info',
        description: (
          <>
            <Text as="span">{`The default facility was changed from `}</Text>
            <Text as="span" fontWeight="heavy">
              {` ${oldDefaultFacility?.name} `}
            </Text>
            <Text as="span">to</Text>
            <Text as="span" fontWeight="heavy">
              {` ${name}`}
            </Text>
          </>
        ),
      });
    }
  } catch (error) {
    yield put(save.error(error));
  }
}
